/*

Lalitha 10/27/2022 3225736869 night jobs UX changes
Raghu 27/10/2022 3225736869 Inputfields and table alignment fixes
Prakash 10/31/2022 3225736869 added classname for buttons and aligned input fields columns.
Poornima 12/07/2022 3225736869 Renamed search night jobs buttons
*/
import {
  Typography,
  Button,
  TextField,
  FormHelperText,
  Tooltip,
  Grid,
} from '@material-ui/core';
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import React, {useState, useEffect, useContext} from 'react';
import DialogBox from '../../../../../components/DialogBox';
import JobDetailsTable from './JobDetailsTable';
import JobExecutionTable from './JobExecutionTable';
import TaskExecutionTable from './TaskExecutionTable';
import AddTaskForm from './AddTaskForm';
import AddIcon from '@material-ui/icons/Add';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {ResetStatus, resetMessage} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import {postAddNightJob} from './../../../../../redux/reducers/NightJobs/AddNightJob';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

const JobDetailsForm = ({jobCode, setValue}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);
  const [task, setTask] = useState(false);
  const [deletedRules, setDeletedRules] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowData, setRowData] = useState({});
  const [oldRuleCode, setOldRuleCode] = useState('');

  const {isLoading, successMsg, errorMsg, jobDetailsData, jobDetailsStatus, addNightJob} =
    useSelector(({addNightJob}) => addNightJob);

  const jobDetails = (jobDetailsData?.taskResponse || []).map((item) => ({
    ...item,
  }));
  const [formData, setFormData] = useState([]);

  const statuses = [
    {key: 'Scheduled', value: 'Scheduled'},
    {key: 'Waiting', value: 'Waiting'},
  ];
  const initialValues = {
    code: jobDetailsData?.jobConfigDetails?.jobCode || '',
    jobName: jobDetailsData?.jobConfigDetails?.jobName || '',
    jobConfigId: jobDetailsData?.jobConfigDetails?.jobConfigId || null,
    description: jobDetailsData?.jobConfigDetails?.jobDescription || '',
    status: jobDetailsData?.jobConfigDetails?.jobStatus || '',
    scheduleExpression: jobDetailsData?.jobConfigDetails?.scheduleExpression || '',
    nextRunTime: jobDetailsData?.jobConfigDetails?.nextRunTime || null,
    lastRunTime: jobDetailsData?.jobConfigDetails?.lastRunTime || null,
  };

  const validationSchema = Yup.object().shape({
    code: initialValues.code ?
      '' :
      Yup.string()
        .required('Job Code is required')
        .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed')
        .required('Job code is required'),
    description: Yup.string().required('Job description is required'),
    status: Yup.mixed().test('status', 'Job status is required', (value) => {
      if (!value) {
        return false;
      } else {
        return true;
      }
    }),
    // nextRunTime: Yup.date().required("Next Run Time is required").nullable(),
    // lastRunTime: Yup.date().required("Next Run Time is required").nullable(),
    scheduleExpression: Yup.string().required('Schedule expression is required'),
  });

  useEffect(() => {
    setFormData([...jobDetails]);
  }, [jobDetailsData]);

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
  };

  const handleTaskClose = () => {
    setTaskOpen(false);
  };

  const handleSubmit = (data) => {
    const passValues = {
      taskRequest: formData.map((item, index) => {
        return {
          taskId: item.taskId ? item.taskId : 0,
          jobCode: '',
          tasktType: item.tasktType,
          taskParameters: item.taskParameters,
          seqNo: item?.seqNo ? item?.seqNo : 0,
          taskCode: item.taskCode,
        };
      }),
      jobCode: data?.code,
      jobConfigId: data?.jobConfigId ? data?.jobConfigId : '',
      jobDescription: data?.description ? data?.description : '',
      jobName: data?.jobName ? data?.jobName : '',
      jobStatus: data?.status ? data?.status : '',
      scheduleExpression: data?.scheduleExpression ? data?.scheduleExpression : '',
      deleteTaskIds: deletedRules,
    };
    dispatch(postAddNightJob(passValues));
  };
  useEffect(() => {
    if (jobDetailsStatus === 200) {
      dispatch(ResetStatus);
    }
  }, []);

  useEffect(() => {
    if (addNightJob === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
    }
  }, [addNightJob]);

  return (
    <>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              setFieldValue,
              handleBlur,
              errors,
              touched,
            } = props;
            return (
              <div>
                <Form autoComplete="off" noValidate>
                  <div>
                    <div className="button-table-spacing-mb justify-content-start">
                      <Button
                        variant="outlined"
                        type="button"
                        disabled={isLoading || successMsg}
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          setValue(0);
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Search Scheduled Jobs
                      </Button>
                    </div>
                    <ErrorBoundaryForComponents>
                      <Grid className="global-field-textfields" container spacing={2}>
                        <>
                          <Grid item xs={4} sm={6} md={4} lg={2} xl={2} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Job Code`}
                              label="Job Code"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="code"
                              required
                              disabled={jobDetailsData?.jobConfigDetails?.jobCode}
                              value={values?.code?.toUpperCase()}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={Boolean(touched.code && errors.code)}
                              fullWidth
                            />
                            <FormHelperText>
                              {touched?.code && errors?.code ? errors?.code : ''}
                            </FormHelperText>
                          </Grid>

                          <Grid item xs={4} sm={6} md={4} lg={4} xl={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Job Description`}
                              label="Job Description"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="description"
                              required
                              value={values.description}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                            <FormHelperText
                              style={{color: 'red'}}
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.description && errors && errors?.description}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={4} sm={6} md={4} lg={2} xl={2} className="form-group">
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                                popper: classes.popper,
                              }}
                              name="status"
                              id="status"
                              size="small"
                              value={values.status}
                              options={statuses.map((each) => each.key)}
                              required
                              onChange={(e, value) => {
                                if (value) {
                                  setFieldValue('status', value);
                                }
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    className={`${classes.labelName} ${classes.selectLabel}`}
                                    variant="outlined"
                                    margin="dense"
                                    name="status"
                                    required
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="Job Status"
                                    placeholder="Select Job Status"
                                  />
                                </div>
                              )}
                            />
                            <FormHelperText
                              style={{color: 'red'}}
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.status && errors && errors?.status}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={4} sm={6} md={4} lg={2} xl={2} className="form-group">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardDateTimePicker
                                  className={` ${classes.labelName} ${classes.datePicker}`}
                                  format="MM/dd/yyyy hh:mm:ss"
                                  placeholder="MM/DD/YYYY"
                                  fullWidth
                                  value={values.nextRunTime}
                                  name="nextRunTime"
                                  // minDate={}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={null}
                                  required
                                  onBlur={handleBlur}
                                  inputVariant="outlined"
                                  label="Next Run Time"
                                  onChange={(val) => {
                                    setFieldValue('nextRunTime', val);
                                  }}
                                  autoOk
                                  margin="dense"
                                  touched={touched?.nextRunTime}
                                  error={Boolean(touched?.nextRunTime && errors?.nextRunTime)}
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                            <FormHelperText
                              style={{color: 'red'}}
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.nextRunTime && errors && errors?.nextRunTime}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={4} sm={6} md={4} lg={2} xl={2} className="form-group">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardDateTimePicker
                                  className={` ${classes.labelName} ${classes.datePicker}`}
                                  format="MM/dd/yyyy hh:mm:ss"
                                  placeholder="MM/DD/YYYY"
                                  fullWidth
                                  value={values.lastRunTime}
                                  name="lastRunTime"
                                  // minDate={}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={null}
                                  required
                                  onBlur={handleBlur}
                                  inputVariant="outlined"
                                  label="Last Run Time"
                                  onChange={(val) => {
                                    setFieldValue('lastRunTime', val);
                                  }}
                                  autoOk
                                  margin="dense"
                                  touched={touched?.lastRunTime}
                                  error={Boolean(touched?.lastRunTime && errors?.lastRunTime)}
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                            <FormHelperText
                              style={{color: 'red'}}
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.lastRunTime && errors && errors?.lastRunTime}
                            </FormHelperText>
                          </Grid>

                          <Grid item xs={4} sm={6} md={4} lg={3} xl={3} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Schedule Expression`}
                              required
                              label="Scheduled Expression"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="scheduleExpression"
                              value={values.scheduleExpression}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                            <FormHelperText
                              style={{color: 'red'}}
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.scheduleExpression && errors && errors?.scheduleExpression}
                            </FormHelperText>
                          </Grid>
                        </>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>

                  <div className={`mt-2`}>
                    <div className="table-header table-card-header">
                      <Typography variant="h4">Tasks</Typography>
                      <Button
                        variant="outlined"
                        className={`search-btn ${classes.buttonRoot}`}
                        onClick={() => {
                          setOpen(true);
                        }}
                      >
                        <AddIcon />
                        Add Task
                      </Button>
                    </div>
                    <JobDetailsTable
                      setIsEditMode={setIsEditMode}
                      setOldRuleCode={setOldRuleCode}
                      setRowData={setRowData}
                      rowData={rowData}
                      setOpen={setOpen}
                      formData={formData}
                      setFormData={setFormData}
                      deletedRules={deletedRules}
                      setDeletedRules={setDeletedRules}
                      jobDetails={jobDetails}
                    />
                  </div>
                  <div className="row justify-content-center mt-3">
                    <Button
                      type="button"
                      onClick={() => handleReset()}
                      variant="outlined"
                      className={`mr-1 reset-btn ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    {formData && formData?.length > 0 ? (
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`ml-1 search-btn ${classes.buttonRoot}`}
                      >
                        Save
                      </Button>
                    ) : (
                      <Tooltip title="Please add atleast one task to continue">
                        <span>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`ml-1 search-btn ${classes.buttonRoot}`}
                            disabled
                          >
                            Save
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                  </div>
                  <div className={`mt-2`}>
                    <div className="table-header table-card-header">
                      <Typography variant="h4">Job Executions</Typography>
                    </div>
                    <JobExecutionTable setTask={setTask} setOpen={setTaskOpen} jobCode={jobCode} />
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <DialogBox
          open={open || isEditMode}
          dialogClose={handleClose}
          hideFooter={true}
          maxWidth={'md'}
          title={(isEditMode && 'Edit Task ') || (open && 'Add Task')}
        >
          <AddTaskForm
            rowData={rowData}
            setFormData={setFormData}
            formData={formData}
            setOpen={setOpen}
            handleClose={handleClose}
            isEditMode={isEditMode}
            oldRuleCode={oldRuleCode}
            setIsEditMode={setIsEditMode}
          />
        </DialogBox>
        <DialogBox
          open={taskOpen}
          dialogClose={handleTaskClose}
          hideFooter={true}
          maxWidth={'md'}
          title={'Task Executions'}
        >
          <div>
            <TaskExecutionTable />
          </div>
        </DialogBox>
      </div>

      {isLoading && !task && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default JobDetailsForm;
